import getConfig from 'next/config';
import Head from 'next/head';
import MobileMenu from 'components/headers/MobileMenu';
import { ReactNode, useState } from 'react';
import Header from 'components/headers/Header';
import boatsetterPaths from 'utils/boatsetterPaths';
import Container from './Container';

const { RAILS_URL } = getConfig().publicRuntimeConfig;

type BlwEntryLayoutProps = {
  background?: string;
  size: string;
  withContainer?: boolean;
  className?: string;
  isAuthenticated?: boolean;
  withNoFlex: boolean;
  noPadding: boolean;
  isMobile: boolean;
  noPaddingMobile: boolean;
  backgroundTop: boolean;
  name: string;
  children: ReactNode;
};

const BlwEntryLayout = ({
  background,
  size,
  withContainer = true,
  className,
  isAuthenticated,
  withNoFlex,
  noPadding,
  isMobile,
  noPaddingMobile,
  backgroundTop,
  name,
  children,
}: BlwEntryLayoutProps) => {
  const pageBackground = /\.(gif|jpg|jpeg|tiff|png)$/i.test(background) ? `url(${background})` : background;

  const classes = [
    'blw PageWrapper NavOffCanvas-push js-off-canvas-item js-off-canvas-close',
    !withContainer || withNoFlex ? 'PageWrapper--noflex PageWrapper--ip-flex' : '',
    isAuthenticated ? 'loggedIn' : '',
    'isHome',
    isMobile ? 'isMobile' : '',
    noPadding ? 'u-pb0 u-sm-pb5' : '',
    noPaddingMobile ? 'u-sm-pb0' : '',
    backgroundTop ? 'PageWrapper--backgroundTop' : '',
    `page-blw-${name}`,
  ]
    .join(' ')
    .trim();

  const canonicalTag = `${RAILS_URL}${boatsetterPaths.listBoat}`;
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <Head>
        <link rel="canonical" href={canonicalTag} key="canonical" />
      </Head>
      <div id="root3" key="r3" style={{ height: '100%', width: '100%', position: 'absolute' }}>
        <div>
          <MobileMenu menuOpen={menuOpen} setMenuOpen={setMenuOpen} isHome greenBg />
        </div>
        <div>
          <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} isHome />
        </div>

        <main>
          <div id="bg-image-div" className={`${classes}`} style={{ backgroundImage: pageBackground }}>
            <div className={`PageWrapper-content w-100 h-100 ${className || ''} u-ip-pv0 u-pt4 u-sm-pt0`}>
              {withContainer ? <Container size={size}>{children}</Container> : children}
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default BlwEntryLayout;
